import React, { useState, useCallback } from "react";
import { FormattedDate, useIntl } from "react-intl";
import { MdCancel, MdCheckCircle, MdExpandMore, MdInfo } from "react-icons/md";
import { formatPercent } from "../../../../../../utils/format";

const criteriaPicks = {
  conforme: {
    style: "conforme",
    icon: {
      component: MdCheckCircle,
      className: "check-icon"
    }
  },
  desconforme: {
    style: "desconforme",
    icon: {
      component: MdCancel,
      className: "error-icon"
    }
  },
  informativo: {
    style: "informativo",
    icon: {
      component: MdInfo,
      className: "informative-icon"
    }
  }
};

const AreaCriteria = ({
  criteria,
  openCriteria,
  toggleCollapse,
  selectedCriteria
}) => {
  const [areaCollapsed, setAreaCollapsed] = useState(false);
  const { formatMessage } = useIntl();

  const hasAreaInfractions = useCallback(() => {
    if (!criteria) return false;
    return !!criteria.find(crit => !crit.conforme);
  }, [criteria]);

  return (
    <div className={`report-section${areaCollapsed ? " collapsed" : ""}`}>
      <h3 onClick={() => setAreaCollapsed(!areaCollapsed)}>
        <MdExpandMore className="collapse-indicator" />{" "}
        {formatMessage({ id: "criterios" })}
        {hasAreaInfractions() ? (
          <MdCancel size={20} className="section-status-icon error" />
        ) : (
          <MdCheckCircle size={20} className="section-status-icon check" />
        )}
      </h3>

      {criteria.map(criterion => {
        if (!criterion.B3Criterio.id) return <React.Fragment key={criterion.id}></React.Fragment>;

        if (!selectedCriteria.includes(criterion.B3Criterio.id)) {
          return <React.Fragment key={criterion.B3Criterio.id}></React.Fragment>;
        }

        let type = "";

        if (criterion.is_informativo) {
          type = "informativo";
        } else {
          if (criterion.conforme) {
            type = "conforme";
          } else {
            type = "desconforme";
          }
        }

        const CriteriaIconPick = criteriaPicks[type].icon;

        return (
          <div
            key={criterion.id}
            className={`
                criteria-information-data
                ${!openCriteria.includes(criterion.id) ? " collapsed" : ""}
                criteria-${criteriaPicks[type].style}
              `}
          >
            <div
              className="criteria-title"
              onClick={() => toggleCollapse(criterion.id)}
            >
              <div className="text">
                <div>
                  <MdExpandMore size="18px" />
                </div>
                <div>{criterion.B3Criterio.nome}</div>
              </div>
              {criterion.status !== "processado" ? (
                <div className="loader tiny"></div>
              ) : (
                <div>
                  <CriteriaIconPick.component
                    size={20}
                    className={CriteriaIconPick.className}
                  />
                </div>
              )}
            </div>
            <div className="criteria-details">
              {criterion.B3Criterio.descricao && (
                <div>
                  <span className="bold">
                    {formatMessage({ id: "descricao" })}:{" "}
                  </span>
                  {criterion.B3Criterio.descricao}
                </div>
              )}
              {criterion.B3Criterio.fonte && (
                <div>
                  <span className="bold">
                    {formatMessage({ id: "fonte" })}:{" "}
                  </span>
                  <a
                    href={criterion.B3Criterio.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {criterion.B3Criterio.fonte}
                  </a>
                </div>
              )}
              {criterion.B3CriterioVersao &&
                criterion.B3CriterioVersao.data && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "data-base" })}:{" "}
                    </span>
                    <FormattedDate
                      value={new Date(criterion.B3CriterioVersao.data)}
                    />
                  </div>
                )}
              {criterion.detalhes_json &&
                criterion.detalhes_json.data_consulta && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "data-consulta" })}:{" "}
                    </span>
                    <FormattedDate
                      value={new Date(criterion.detalhes_json.data_consulta)}
                    />
                  </div>
                )}
              {criterion.is_informativo ? (
                <>
                  {criterion.descricao &&
                    criterion.descricao.map((infraction, index) => (
                      <div key={index} className="infraction">
                        {infraction.length > 0 && (
                          <div>
                            <MdInfo size={20} className="informative-icon" />
                            <div>
                              <span className="bold">
                                {infraction[0].nome}:{" "}
                              </span>
                              {infraction[0].valor}
                            </div>
                          </div>
                        )}
                        {infraction.length > 1 &&
                          infraction.slice(1).map(detail => (
                            <p key={detail.nome}>
                              <span className="bold">{detail.nome}: </span>
                              {detail.valor}
                            </p>
                          ))}
                      </div>
                    ))}
                </>
              ) : (
                <>
                  {criterion.conforme ? (
                    <>
                      {criterion.B3Criterio.slug === "identifica_car" ? (
                        <div className="infraction">
                          <div className="infraction">
                            <span className="bold">
                              {formatMessage({ id: "infracoes-encontradas" })}:
                            </span>
                          </div>

                          {criterion.descricao &&
                            criterion.descricao.map((infraction, index) => (
                              <div key={index} className="infraction">
                                {infraction.length > 0 && (
                                  <div>
                                    <div className="status-icon"></div>
                                    <div>
                                      <span className="bold">
                                        {infraction[0].nome}:{" "}
                                      </span>
                                      {infraction[0].valor}
                                    </div>
                                  </div>
                                )}
                                {infraction.length > 1 &&
                                  infraction.slice(1).map(detail => (
                                    <p key={detail.nome}>
                                      <span className="bold">
                                        {detail.nome}:{" "}
                                      </span>
                                      {detail.valor}
                                    </p>
                                  ))}
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div className="infraction">
                          <div>
                            <div className="status-icon">
                              <MdCheckCircle size={20} className="check-icon" />
                            </div>
                            <span className="bold">
                              {formatMessage({ id: "nenhuma-infracao" })}
                            </span>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div>
                      {criterion.detalhes_json &&
                         criterion.detalhes_json.porcentagem_decimal != null && (
                          <div className="infraction">
                            <span className="bold">
                              {formatMessage({ id: "porcentagem-sobreposicao" })}:{" "}
                            </span>
                            <span>
                              {formatPercent(
                                criterion.detalhes_json.porcentagem_decimal
                              )}
                            </span>
                          </div>
                        )}

                      <div className="infraction">
                        <span className="bold">
                          {formatMessage({ id: "infracoes-encontradas" })}:
                        </span>
                      </div>

                      {criterion.B3Criterio.slug === "supressao_vegetacao_nativa" ? (() => {
                        let detalhes = [];
                        try {
                          const raw = criterion.detalhes_json && criterion.detalhes_json.detalhes;
                          detalhes = typeof raw === "string" ? JSON.parse(raw) : (raw || []);
                        } catch (e) {
                          detalhes = [];
                        }

                        return detalhes.map((detalhe, index) => (
                          <div key={index} className="infraction">
                            <div>
                              <div className="status-icon">
                                <MdCancel size={20} className="error-icon" />
                              </div>
                              <div>
                                <span className="bold">
                                  {formatMessage({ id: "descricao" })}:{" "}
                                </span>
                                {detalhe.descricao}
                              </div>
                            </div>
                            <p>
                              <span className="bold">
                                {formatMessage({ id: "area-ha" })}:{" "}
                              </span>
                              {detalhe.area_ha}
                            </p>
                            <p>
                              <span className="bold">
                                {formatMessage({ id: "porcentagem-sobreposicao" })}:{" "}
                              </span>
                              {detalhe.porcentagem}
                            </p>
                            <p>
                              <span className="bold">
                                {formatMessage({ id: "bioma" })}:{" "}
                              </span>
                              {detalhe.bioma}
                            </p>
                          </div>
                        ));
                      })() : (
                        criterion.descricao &&
                          criterion.descricao.map((infraction, index) => (
                            <div key={index} className="infraction">
                              {infraction.length > 0 && (
                                <div>
                                  <div className="status-icon">
                                    <MdCancel size={20} className="error-icon" />
                                  </div>
                                  <div>
                                    <span className="bold">
                                      {infraction[0].nome}:{" "}
                                    </span>
                                    {infraction[0].valor}
                                  </div>
                                </div>
                              )}
                              {infraction.length > 1 &&
                                infraction.slice(1).map(detail => (
                                  <p key={detail.nome}>
                                    <span className="bold">{detail.nome}: </span>
                                    {detail.valor}
                                  </p>
                                ))}
                            </div>
                          ))
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AreaCriteria;
